module.exports = __webpack_public_path__ + "static/media/header-custom.8ed42b07.jpg";